// extracted by mini-css-extract-plugin
export var container = "styles-module--container---XVuc";
export var about = "styles-module--about--Xewbz";
export var intro = "styles-module--intro--w9+-r";
export var logo = "styles-module--logo--SZEz4";
export var button = "styles-module--button--DIoCP";